export default {
  'resetpassword.maintext':
    'Um Ihr Passwort zurückzusetzen, geben Sie bitte das neue Passwort in beide Felder ein',
  'resetpassword.retypepassword': 'Passwort erneut eingeben',
};
